import { getAllInstitutions } from '@adornis/buchungsheld-db/api/institution.js';
import { activatePlugin, registerPlugin } from '@adornis/bh-plugin-system/plugin.js';
import { icsrmInstitutionStatisticsPlugin } from './institution-statistics/icsrm-institiiution-statistics-plugin.js';
import { ikhInvoiceManagementPlugin } from './invoice-management/ikh-invoice-management-plugin.js';
import { ikhInvoiceUserInvoicesTable } from './invoice-user-invoices-table/invoice-user-invoices-table-ikh.js';
import { icsrmParticipationOverviewPlugin } from './participation-overview/icsrm-participation-overview.js';
import { demoPaymentPlugin } from './payment/demo-payment-plugin.js';
import { ikhPaymentPlugin } from './payment/ikh-payment-plugin.js';
import { immediateParticipationPaymentPlugin } from './payment/immediate-participation.js';
import { sdPaymentPlugin } from './payment/sd-payment-plugin.js';
import { icsrmRegistrationProductEntryRequirementsPlugin } from './product-entry-requirements/product-entry-requirements-icsrm.js';
import { icsrmRegistrationProductWaitinglistPriorityRulesPlugin } from './product-waitinglist-priority-rules/product-waitinglist-priority-rules-icsrm.js';
import { testRegistrationProductWaitinglistPriorityRulesPlugin } from './product-waitinglist-priority-rules/product-waitinglist-priority-rules-test.js';
import { initDefaultPlugins } from './register-default-plugins.js';
import { csjensblankRegistrationUserDataPlugin } from './registration-user-data/csjensblank-registration-user-data-plugin.js';
import { demoRegistrationUserDataPlugin } from './registration-user-data/demo-registration-user-data-plugin.js';
import { deutschkursRegistrationUserDataPlugin } from './registration-user-data/deutschkurs-registration-user-data-plugin.js';
import { icsrmFollowUpRegistrationUserDataPlugin } from './registration-user-data/icsrm-follow-up-registration-user-data-plugin.js';
import { icsrmRegistrationUserDataPlugin } from './registration-user-data/icsrm-registration-user-data-plugin.js';
import { ikhRegistrationUserDataPlugin } from './registration-user-data/ikh-registration-user-data-plugin.js';
import { mzsRegistrationUserDataPlugin } from './registration-user-data/mzs-registration-user-data-plugin.js';
import { schluesselkompetenzenRegistrationUserDataPlugin } from './registration-user-data/schluesselkompetenzen-registration-user-data-plugin.js';
import { sdRegistrationUserDataPlugin } from './registration-user-data/sd-registration-user-data-plugin.js';
import { sdTutorRegistrationUserDataPlugin } from './registration-user-data/sd-tutor-registration-user-data-plugin.js';
import { tudaRegistrationUserDataPlugin } from './registration-user-data/tuda-registration-user-data-plugin.js';
import { buildYourOwnAiStammdatenPlugin } from './stammdaten/buildYourAi-stammdaten-plugin.js';
import { ckRegistrationStammdatenPlugin } from './stammdaten/ck-stammdaten-plugin.js';
import { cpgRegistrationStammdatenPlugin } from './stammdaten/cpg-stammdaten.plugin.js';
import { csjensblanksRegistrationStammdatenPlugin } from './stammdaten/csjensblank-stammdaten-plugin.js';
import { demoRegistrationStammdatenPlugin } from './stammdaten/demo-stammdaten-plugin.js';
import { deutschkursRegistrationStammdatenPlugin } from './stammdaten/deutschkurs-stammdaten-plugin.js';
import { digitellRegistrationStammdatenPlugin } from './stammdaten/digitell-stammdaten-plugin.js';
import { fjnRegistrationStammdatenPlugin } from './stammdaten/fjn-stammdaten-plugin.js';
import { icsrmFollowUpStammdatenPlugin } from './stammdaten/icsrm-follow-up-stammdaten-plugin.js';
import { icsrmRegistrationStammdatenPlugin } from './stammdaten/icsrm-stammdaten-plugin.js';
import { ikhRegistrationStammdatenPlugin } from './stammdaten/ikh-stammdaten-plugin.js';
import { mzsRegistrationStammdatenPlugin } from './stammdaten/mzs-stammdaten-plugin.js';
import { pbsRegistrationStammdatenPlugin } from './stammdaten/pbs-stammdaten.plugin.js';
import { schluesselkompetenzenRegistrationStammdatenPlugin } from './stammdaten/schluesselkompetenzen-stammdaten-plugin.js';
import { sdelRegistrationStammdatenPlugin } from './stammdaten/sd-el-stammdaten-plugin.js';
import { sdRegistrationStammdatenPlugin } from './stammdaten/sd-stammdaten-plugin.js';
import { sdTutorRegistrationStammdatenPlugin } from './stammdaten/sd-tutor-stammdaten-plugin.js';
import { stRegistrationStammdatenPlugin } from './stammdaten/st-stammdaten-plugin.js';
import { tttRegistrationStammdatenPlugin } from './stammdaten/ttt-stammdaten-plugin.js';
import { tudaRegistrationStammdatenPlugin } from './stammdaten/tuda-stammdaten-plugin.js';
import { ikhWorkshopParticipationExportPlugin } from './workshop-participation-export/workshop-participation-export-ikh.js';

export const registerAllBuchungsheldPlugins = () => {
  initDefaultPlugins();

  registerPlugin(ikhRegistrationUserDataPlugin);
  registerPlugin(ikhRegistrationStammdatenPlugin);
  registerPlugin(ikhPaymentPlugin);
  registerPlugin(ikhInvoiceManagementPlugin);
  registerPlugin(ikhInvoiceUserInvoicesTable);
  registerPlugin(sdPaymentPlugin);
  registerPlugin(immediateParticipationPaymentPlugin);
  registerPlugin(sdRegistrationUserDataPlugin);
  registerPlugin(sdRegistrationStammdatenPlugin);
  registerPlugin(tudaRegistrationUserDataPlugin);
  registerPlugin(tudaRegistrationStammdatenPlugin);
  registerPlugin(icsrmRegistrationProductEntryRequirementsPlugin);
  registerPlugin(icsrmRegistrationProductWaitinglistPriorityRulesPlugin);
  registerPlugin(testRegistrationProductWaitinglistPriorityRulesPlugin);
  registerPlugin(icsrmRegistrationUserDataPlugin);
  registerPlugin(icsrmRegistrationStammdatenPlugin);
  registerPlugin(csjensblanksRegistrationStammdatenPlugin);
  registerPlugin(pbsRegistrationStammdatenPlugin);
  registerPlugin(sdelRegistrationStammdatenPlugin);
  registerPlugin(stRegistrationStammdatenPlugin);
  registerPlugin(cpgRegistrationStammdatenPlugin);
  registerPlugin(fjnRegistrationStammdatenPlugin);
  registerPlugin(sdTutorRegistrationStammdatenPlugin);
  registerPlugin(tttRegistrationStammdatenPlugin);
  registerPlugin(ikhWorkshopParticipationExportPlugin);
  registerPlugin(ckRegistrationStammdatenPlugin);
  registerPlugin(mzsRegistrationStammdatenPlugin);
  registerPlugin(mzsRegistrationUserDataPlugin);
  registerPlugin(sdTutorRegistrationUserDataPlugin);
  registerPlugin(digitellRegistrationStammdatenPlugin);
  registerPlugin(buildYourOwnAiStammdatenPlugin);
  registerPlugin(csjensblankRegistrationUserDataPlugin);
  registerPlugin(icsrmInstitutionStatisticsPlugin);
  registerPlugin(icsrmParticipationOverviewPlugin);
  registerPlugin(icsrmFollowUpStammdatenPlugin);
  registerPlugin(icsrmFollowUpRegistrationUserDataPlugin);
  registerPlugin(deutschkursRegistrationStammdatenPlugin);
  registerPlugin(deutschkursRegistrationUserDataPlugin);
  registerPlugin(schluesselkompetenzenRegistrationStammdatenPlugin);
  registerPlugin(schluesselkompetenzenRegistrationUserDataPlugin);

  // DEMO
  registerPlugin(demoRegistrationStammdatenPlugin);
  registerPlugin(demoRegistrationUserDataPlugin);
  registerPlugin(demoPaymentPlugin);
};

export const activateAllUsedPlugins = async () => {
  const allInstitutions = await getAllInstitutions()({ _id: 1, plugins: 1 });

  for (const institution of allInstitutions) {
    for (const pluginID of institution.plugins ?? []) {
      try {
        activatePlugin(pluginID, institution._id);
      } catch (error) {
        console.error(`Failed to activate plugin "${pluginID}" for institution "${institution._id}".`, error);
      }
    }
  }
};
